import { Box, Button, Typography } from '@mui/material'
import AddFile from '../Organization/AddFile'
import { useContext, useState } from 'react'
import { AddIcon } from '../Svgs'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'
import { AbilityContext } from '../../utils/AbilityUtil'

interface StartNewFileMinimizedProps {}

const StartNewFileMinimizedComponent: React.FC<
  StartNewFileMinimizedProps
> = ({}) => {
  const [isAddFileDialogOpen, setIsAddFileDialogOpen] = useState(false)

  const ability = useContext(AbilityContext)

  return (
    <>
      <Button
        disabled={ability.cannot(
          AttributeActionNames.Create,
          AttributeResourceNames.Files,
        )}
        disableRipple
        onClick={() => setIsAddFileDialogOpen(true)}
        sx={{
          width: '100%',
          borderRadius: '0.4rem',
          background: ability.cannot(
            AttributeActionNames.Create,
            AttributeResourceNames.Files,
          )
            ? '#F5F5F5'
            : '#E5F0FF',
          fontSize: '0.82rem',
          lineHeight: 'normal',
          color: '#06004A',
          textTransform: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '0.5rem',
          p: '0.75rem',
        }}
      >
        <Box display='flex'>
          <AddIcon
            color={
              ability.cannot(
                AttributeActionNames.Create,
                AttributeResourceNames.Files,
              )
                ? '#BBBCBC'
                : '#1705E5'
            }
          />
        </Box>
        Start a New File
      </Button>
      <AddFile
        isOpen={isAddFileDialogOpen}
        handleClose={() => setIsAddFileDialogOpen(false)}
      />
    </>
  )
}

export default StartNewFileMinimizedComponent
